import React from 'react';
import EnterFuncNavi from './enterFuncNavi';
import SlideView from './slideView';
import { SettingMenu } from '../components/SettingMenu';

export default class EnterSplitView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      page: null,
      param: null,
      settingMenu: false,
    };
  }

  // eslint-disable-next-line no-unused-vars
  componentWillReceiveProps(nextProps) {
    //urlが変わったらロード
    if (this.state.url != this.props.url) {
      this.setState({ url: this.props.url });
    }
  }

  /**
   * 通常のページのロード
   * @param {react.component} pagecomponent
   */
  loadPage(pagecomponent, param) {
    this.setState({
      page: pagecomponent,
      param,
      settingMenu: false,
    });
  }

  /**
   * 設定ページのロード
   */
  loadSettingPage(pagecomponent, param) {
    this.setState({
      page: pagecomponent,
      param,
      settingMenu: true,
    });
  }

  render() {
    return (
      <div className={`splitview__item sys-splitview-${this.props.vw}`}>
        <EnterFuncNavi
          vw={this.props.vw}
          loadPage={this.loadPage.bind(this)}
          loadSettingPage={this.loadSettingPage.bind(this)}
        />
        <Wrapper
          {...this.state}
          vw={this.props.vw}
          loadSettingPage={this.loadSettingPage.bind(this)}
        >
          <Page
            {...this.state}
            vw={this.props.vw}
            loadPage={this.loadPage.bind(this)}
          />
        </Wrapper>
        <SlideView vw={this.props.vw} />
      </div>
    );
  }
}

/**
 * ページの出し分け
 * @param {object}} props
 */
const Wrapper = props => {
  if (props.settingMenu) {
    return (
      <div className='rail__main'>
        <div id='main' className='setting-main' style={{ height: '100%' }}>
          <div className='setting-main__header'>
            <h1>各種設定</h1>
          </div>
          <SettingMenu vw={props.vw} loadSettingPage={props.loadSettingPage} />
          {props.children}
        </div>
      </div>
    );
  } else {
    return <div className='rail__main'>{props.children}</div>;
  }
};

/**
 * 各画面
 */
const Page = props => {
  if (props.page) {
    const _page = props.page;
    return (
      <_page vw={props.vw} param={props.param} loadPage={props.loadPage} />
    );
  }
  return <div />;
};



// WEBPACK FOOTER //
// ./src/components/enterSplitView.js